import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, List, Checkbox, ListItemText } from '@mui/material';
import { Button, Dialog, TextField } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { get, set } from '@totalsoft/change-tracking-react';
import { isValid } from '@totalsoft/pure-validations-react';
import { valueOrDefault } from 'utils/functions';
import { emptyString } from 'constants/defaultValues';

const StateTransitionReasonsComponent = ({ transitionConfig, onCloseModal, onToggleSelectItem, onSave, validation, lens, reasons }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='state-transition-reasons-dialog'
      open
      onClose={onCloseModal}
      fullWidth
      maxWidth={'sm'}
      disableBackdropClick
      title={t('Offer.Edit.AllowedState.Title')}
      content={
        <>
          <TextField
            id={'offerHeader_state_comment'}
            required={lens.commentRequired |> get}
            disabled={!transitionConfig.requestComment}
            fullWidth
            value={lens.commentText |> get |> valueOrDefault(emptyString)}
            onChange={lens.commentText |> set}
            label={t('Offer.Edit.AllowedState.Comment')}
            multiline={true}
            error={!isValid(validation.commentText)}
            inputProps={{
              maxLength: 255
            }}
          />
          <List>
            {reasons &&
              reasons.length > 0 &&
              reasons.map((reason, idx) => (
                <ListItem key={reason.documentStateXReasonId} disableGutters={true}>
                  <Checkbox
                    checked={reason.selected}
                    onChange={() => onToggleSelectItem(reason.reasonId)}
                    id={'offerHeader_state_comment_reason_' + idx + 'selected'}
                  />
                  <ListItemText primary={reason.description} id={'offerHeader_state_comment_reason_' + idx + 'description'} />
                </ListItem>
              ))}
          </List>
        </>
      }
      actions={
        <>
          <Button color='primary' id={'offerHeader_state_comment_saveBtn'} onClick={onSave}>
            {t('General.Save')}
          </Button>
          <Button color='primary' id={'offerHeader_state_comment_closeBtn'} onClick={onCloseModal}>
            {t('General.Close')}
          </Button>
        </>
      }
    />
  );
};

StateTransitionReasonsComponent.propTypes = {
  transitionConfig: PropTypes.object.isRequired,
  reasons: PropTypes.array,
  onCloseModal: PropTypes.func.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  lens: PropTypes.object.isRequired
};

export default StateTransitionReasonsComponent;
